import { Box, useMediaQuery } from '@mui/material';
import { APP_SCALE, DESKTOP_BREAKPOINT } from 'constant/app.config';

export default function ScaledDialogContent({ children }) {
  const isDesktop = useMediaQuery(`(min-width:${DESKTOP_BREAKPOINT}px)`);

  if (!isDesktop) {
    return <>{children}</>;
  }

  return (
    <Box
      sx={{
        position: 'fixed', // 🔥 KEY
        inset: 0, // 🔥 top:0 right:0 bottom:0 left:0
        transform: `scale(${APP_SCALE})`,
        transformOrigin: 'top left',

        width: `calc(100vw / ${APP_SCALE})`,
        height: `calc(100vh / ${APP_SCALE})`,

        overflow: 'auto',
        backgroundColor: 'inherit',
      }}
    >
      {children}
    </Box>
  );
}
